import { render } from "./HeroSpinning.vue?vue&type=template&id=3c7c41e9&scoped=true"
const script = {}

import "./HeroSpinning.vue?vue&type=style&index=0&id=3c7c41e9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c7c41e9"]])

export default __exports__